import React from 'react';
import { Alert, Box, Chip, Typography } from '@mui/material';
import type { ReservationPartyLookup } from '../../Service/reservationPartiesLookupMapper';

interface Props {
  applicantPartyId?: number;
  invoiceBuyerPartyId?: number;
  fundingPartyId?: number;
  parties: ReservationPartyLookup[];
}

const resolveLabel = (partyId: number | undefined, parties: ReservationPartyLookup[]): string => {
  if (!partyId) {
    return '-';
  }

  const match = parties.find((party) => party.id === partyId);
  return match?.label ?? `Party #${partyId}`;
};

const ReservationRoleSummary: React.FC<Props> = ({
  applicantPartyId,
  invoiceBuyerPartyId,
  fundingPartyId,
  parties,
}) => {
  const applicantLabel = resolveLabel(applicantPartyId, parties);
  const invoiceBuyerResolvedPartyId = invoiceBuyerPartyId ?? applicantPartyId;
  const invoiceBuyerLabel = resolveLabel(invoiceBuyerResolvedPartyId, parties);
  const fundingLabel = resolveLabel(fundingPartyId, parties);
  const invoicePreviewBuyerPartyId = fundingPartyId ?? invoiceBuyerResolvedPartyId;
  const invoicePreviewRecipientPartyId = fundingPartyId ? invoiceBuyerResolvedPartyId : undefined;
  const invoicePreviewBuyerLabel = resolveLabel(invoicePreviewBuyerPartyId, parties);
  const invoicePreviewRecipientLabel = resolveLabel(invoicePreviewRecipientPartyId, parties);

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Podsumowanie ról
      </Typography>
      <Alert severity="info" sx={{ mb: 1 }}>
        Wybierz stronę zgłaszającą jako formalną stronę rezerwacji. Stronę faktury i stronę finansującą
        uzupełnij tylko wtedy, gdy różnią się od strony zgłaszającej.
      </Alert>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Chip label={`Strona zgłaszająca: ${applicantLabel}`} size="small" color="default" />
        <Chip label={`Strona faktury: ${invoiceBuyerLabel}`} size="small" color="primary" />
        <Chip label={`Strona finansująca: ${fundingLabel}`} size="small" color="secondary" />
      </Box>
      <Box sx={{ mt: 1 }}>
        <Typography variant="body2" fontWeight={600}>
          Na fakturze będzie:
        </Typography>
        <Typography variant="body2">Nabywca: {invoicePreviewBuyerLabel}</Typography>
        <Typography variant="body2">
          Odbiorca: {invoicePreviewRecipientPartyId ? invoicePreviewRecipientLabel : 'brak'}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReservationRoleSummary;
